import {apiClient} from "@leap4/frontend"

export async function getTaskTypes(): Promise<string[]>{
    const { data } = await apiClient.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/task/enum/types`);
    return data;
}